import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import qs from 'qs'
import { defaultInstance } from 'services'
import { removeEmpty } from 'utils'
import { responseSuccess, responseError } from 'utils/response'

export const mapValueList = (item) => {
  const type_id = item?.value_list_type?.value_list_type_id
  return {
    key: uuidv4(),
    id: item?.value_list_id,
    code: item?.value_list_code,
    name: item?.value_list_name,
    description: item?.value_list_description,
    type_id,
    type: item?.value_list_type?.value_list_type_code,
  }
}

export const mapSubTask = (item) => {
  return {
    key: uuidv4(),
    id: item?.report_task_id,
    report_header_id: item?.report_header_id,
    task_name: item?.task_name,
    parent_task_id: item?.parent_task_id,
    assignee_id: item?.task_assignee_id,
    assignee_name: item?.task_assignee?.employee?.employee_name_th,
    priority: item?.task_priority?.value_list_name,
    startDate: item?.task_start_date,
    dueDate: item?.task_due_date,
    status: item?.task_status?.value_list_name,
    task_type_id: item?.task_type_id,
    task_status_id: item?.task_status_id,
    task_priority_id: item?.task_priority_id,
    result: item?.task_result,
    description: item?.task_description,
    isEdit: item?.is_edit,
    isAnswer: item?.is_answer,
    isOverdue: item?.is_overdue || item?.is_overdued,
  }
}

export const mapTask = (item) => {
  const orgStructure = item?.task_assignee?.employee?.org_structure
  return {
    key: uuidv4(),
    id: item?.report_task_id,
    report_header_id: item?.report_header_id,
    task_name: item?.task_name,
    parent_task_id: item?.parent_task_id,
    assignee_id: item?.task_assignee_id,
    assignee_name: item?.task_assignee?.employee?.employee_name_th,
    organization: `${orgStructure?.company?.company_name}/${orgStructure?.group?.group_name}/${orgStructure?.business_unit?.bu_name}/${orgStructure?.division?.division_name}/${orgStructure?.department?.department_name}/${orgStructure?.section?.section_name}`,
    priority: item?.task_priority?.value_list_name,
    startDate: item?.task_start_date,
    dueDate: item?.task_due_date,
    status: item?.task_status.value_list_name,
    task_type_id: item?.task_type_id,
    task_status_id: item?.task_status_id,
    task_priority: item?.task_priority_id,
    child_task: _.map(item?.child_task, mapSubTask),
    result: item?.task_result,
    description: item?.task_description,
    isEdit: item?.is_edit,
    isAnswer: item?.is_answer,
    isOverdue: item?.is_overdue,
  }
}

export const mapAnotherTask = (item) => {
  const orgStructure = item?.task_assignee?.employee?.org_structure
  return {
    key: uuidv4(),
    id: item?.report_task_id,
    report_header_id: item?.report_header_id,
    task_name: item?.task_name,
    parent_task_id: item?.parent_task_id,
    assignee_id: item?.task_assignee_id,
    assignee_name: item?.task_assignee?.employee?.employee_name_th,
    organization: `${orgStructure?.company?.company_name}/${orgStructure?.group?.group_name}/${orgStructure?.business_unit?.bu_name}/${orgStructure?.division?.division_name}/${orgStructure?.department?.department_name}/${orgStructure?.section?.section_name}`,
    priority: item?.task_priority?.value_list_name,
    startDate: item?.task_start_date,
    dueDate: item?.task_due_date,
    status: item?.task_status.value_list_name,
    task_type_id: item?.task_type_id,
    task_type: item?.task_type?.value_list_code,
    task_status_id: item?.task_status_id,
    task_priority: item?.task_priority_id,
    child_task: _.map(item?.children_task, mapSubTask),
    description: item?.task_description,
    result: item?.task_result,
    isEdit: item?.is_edit,
    isAnswer: item?.is_answer,
    isOverdue: item?.is_overdued,
  }
}

export const mapIncident = (item) => {
  return {
    key: uuidv4(),
    report_header_id: item?.report_header_id,
    topic: item?.incident_topic,
    reporter: item?.reporter?.employee?.employee_name_th,
    risk_owner: item?.risk_owner_org_name,
    reportType: item?.report_type.report_type_name,
    report_task: _.map(item?.report_task, mapTask),
    canEdit: item?.can_edit,
    canDelete: item?.can_delete,
    status: item?.report_status.report_status_name_en,
    apStatus: item?.ap_status,
    isSignificant: item?.is_significant,
  }
}

export const getIncidentApiById = (id) => {
  const config = {
    method: 'get',
    url: `/api/v1/incident/${id}`,
  }
  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      return responseError({ message: err.message })
    })
}

export const getIncidentApi = ({
  incident_topic,
  reporter_company_id,
  report_type_id,
  report_status_id,
  risk_co_company_id,
  risk_owner_company_id,
  date_from,
  date_to,
  has_task,
  parent_only,
  task_status_id,
  assignee_id,
  page,
  size,
}) => {
  let task_assignee_id = assignee_id
  const params = removeEmpty({
    incident_topic,
    reporter_company_id,
    report_type_id,
    report_status_id,
    risk_co_company_id,
    risk_owner_company_id,
    date_from,
    date_to,
    has_task,
    parent_only,
    task_status_id,
    task_assignee_id,
    page,
    size,
  })
  const config = {
    method: 'get',
    url: `/api/v1/incident/`,
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0) {
        return responseSuccess({
          data: {
            items: _.map(res.data?.items, mapIncident),
            total: res.data.total,
            page: res.data.page,
            size: res.data.size,
          },
        })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      return responseError({ message: err.message })
    })
}

export const getTaskApi = ({
  incident_id,
  reporter_company_id,
  report_status_id,
  risk_co_company_id,
  risk_owner_company_id,
  date_from,
  date_to,
  not_incident,
  me_only,
  parent_only,
  task_type_code,
  assignee_id,
  incident_topic,
  report_type_id,
  has_task,
  task_status_id,
}) => {
  const params = removeEmpty({
    incident_id,
    reporter_company_id,
    report_status_id,
    risk_co_company_id,
    risk_owner_company_id,
    date_from,
    date_to,
    not_incident,
    me_only,
    parent_only,
    task_type_code,
    assignee_id,
    incident_topic,
    report_type_id,
    has_task,
    task_status_id,
  })

  const config = {
    method: 'get',
    url: `/api/v1/task`,
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0) {
        return responseSuccess({ data: _.map(res.data, mapAnotherTask) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      return responseError({ message: err.message })
    })
}

export const getTaskByIdApi = (id) => {
  const config = {
    method: 'get',
    url: `/api/v1/task${id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0) {
        return responseSuccess({ data: _.map(res.data, mapTask) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      return responseError({ message: err.message })
    })
}

export const createTaskApi = ({
  report_header_id,
  parent_task_id,
  task_name,
  task_assignee_id,
  task_due_date,
  task_type_id,
  task_status_id,
  task_priority_id,
  task_result,
  task_description,
  task_start_date,
}) => {
  const params = removeEmpty({
    report_header_id,
    parent_task_id,
    task_name,
    task_assignee_id,
    task_due_date,
    task_type_id,
    task_status_id,
    task_priority_id,
    task_result,
    task_description,
    task_start_date,
  })

  const config = {
    method: 'post',
    url: `/api/v1/task`,
    data: params,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const updateTaskApi = (
  id,
  {
    report_header_id,
    parent_task_id,
    task_name,
    task_assignee_id,
    task_due_date,
    task_type_id,
    task_status_id,
    task_priority_id,
    task_result,
    task_description,
    task_start_date,
  }
) => {
  const params = removeEmpty({
    report_header_id,
    parent_task_id,
    task_name,
    task_assignee_id,
    task_due_date,
    task_type_id,
    task_status_id,
    task_priority_id,
    task_result,
    task_description,
    task_start_date,
  })
  const config = {
    method: 'patch',
    url: `/api/v1/task/${id}`,
    data: params,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const deleteTaskApi = (id) => {
  const config = {
    method: 'delete',
    url: `/api/v1/task/${id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const getValueListApi = (id) => {
  const value_list_type_id = id
  const config = {
    method: 'get',
    url: `/api/v1/value_list`,
    value_list_type_id,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0) {
        return responseSuccess({ data: _.map(res.data?.items, mapValueList) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const getTaskByParams = (incident_id, not_incident, me_only, task_type_code) => {
  const params = removeEmpty({
    incident_id,
    not_incident,
    me_only,
    task_type_code,
  })

  const config = {
    method: 'get',
    url: `/api/v1/task`,
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0) {
        return responseSuccess({ data: res?.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
